module.exports = __webpack_public_path__ + "static/media/meeting-custom-date-inactive.b06c3fe7.svg";